const uiLabels = JSON.parse(document.querySelector('#finxful-ui-labels')?.textContent || '{}');
const menuButton = document.querySelector('#menu-toggle');
const menu = document.querySelector('#mobile-nav');
function setMenu(open) {
  menu.hidden = !open;
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? (uiLabels.menuClose || 'Menü schließen') : (uiLabels.menuOpen || 'Menü öffnen'));
  menuButton.title = open ? (uiLabels.menuClose || 'Menü schließen') : (uiLabels.menuOpen || 'Menü öffnen');
}
menuButton.addEventListener('click', () => setMenu(menu.hidden));
menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && !menu.hidden) {
    setMenu(false);
    menuButton.focus();
  }
});
if (window.lucide) lucide.createIcons();
